import {ActiveRecord} from '../ActiveRecord';
import config from 'config';
import ValidationError from '../../utilites/networkErrors/ValidationError';

export const STATUS_INITIAL = 'Initial';
export const STATUS_PUBLISH = 'Published';
export const STATUS_RESULT_ANNOUNCED = 'Result Announced';

export const TYPE_BINGO = 'Bingo';
export const TYPE_BEST_PLAYER = 'Best Player';
export const TYPE_MATCH_RESULT = 'Match Result';

export const transformDate = (date)  => date instanceof Date ? date.getTime() : date;

export interface IVotingDTO {
  id?: string;
  status: string;
  end_time: number;
  start_time: number;
}

/**
 * @property event_id
 */
export default class Voting extends ActiveRecord {
  id: string;
  status: string;
  eventId: string;
  start_time: Date;
  end_time: Date;

  static path = `${config.backOfficeBasePath}/events/:eventId/votings`;

  static validateConstraints = {
    start_time: {
      presence: {message: '^Please choose a start time'}
    },
    end_time: {
      presence: {message: '^Please choose an end time'},
      greaterThan: {
        key:'start_time',
        message: '^End time can\'t be less than start time'
      }
    }
  };

  _getModel() {
    return Voting;
  }

  get _createUrl() {
    return `${config.backOfficeBasePath}/events/:eventId/votings/bingo`.replace(':eventId', this.eventId);
  }

  get _publishUrl() {
    return this._prepareUrl(this.id) + '/publish';
  }

  get isInitial() {
    return this.status === STATUS_INITIAL;
  }

  get isPublished() {
    return this.status === STATUS_PUBLISH;
  }

  get isAnnounced() {
    return this.status === STATUS_RESULT_ANNOUNCED;
  }

  get canPublish() {
    return !this.isNew() && this.isInitial;
  }

  async publish() {
    if (!this.canPublish) {
      throw 'Can\'t publish';
    }

    let res = await this._networkLayer.patch(this._publishUrl);
    let data = await res.json();

    this._afterSave(data);

    return this;
  }

  protected async _createRecord(dataForSave) {
    return await this._networkLayer.postJson(this._createUrl, dataForSave);
  }

  protected async _updateRecord(dataForSave) {
    return await this._networkLayer.putJson(this._prepareUrl(this.id), dataForSave);
  }

  _parseData(data: IVotingDTO): any {
    return {
      id: data.id,
      status: data.status,
      end_time: data.end_time ? new Date(data.end_time): null,
      start_time: data.start_time ? new Date(data.start_time): null
    };
  }

  prepareForSave() {
    let { end_time, start_time} = this;

    return {
      end_time: transformDate(end_time),
      start_time: transformDate(start_time)
    };
  }

  get canAnnounceResult() {
    return !this.isNew() && this.isPublished
      && !this.isAnnounced && this.end_time && this.end_time.getTime() < (new Date()).getTime();
  }
}



// WEBPACK FOOTER //
// ./src/api/voting/base.ts